const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
      if (entry.isIntersecting) {
          if ( entry.target.classList.contains('wp-block-sowmedia-animated-number') ) {
              start_counter( entry.target.getAttribute('data-number'), entry.target.querySelector('.wp-block-sowmedia-number__count') );
          }
          observer.unobserve(entry.target);
      }
  });
});

document.addEventListener("DOMContentLoaded", function(event) {

  document.querySelectorAll('.schema-faq-question').forEach((item, i) => {

      item.onclick = () => {
  
        item.parentNode.classList.toggle('schema-faq-section--open');
  
      };
  });

  function slickInit(){

    jQuery('.wp-block-sowmedia-posts.is-view-slider .posts').slick(
        {
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            infinite: false,
            arrows: false,
            dots: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                }
            },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                    }
                }
            ]
        }
    ) ;

    jQuery('.mobile-slider').slick(
      {
          slidesToShow: 4,
          slidesToScroll: 0,
          autoplay: false,
          infinite: false,
          arrows: false,
          dots: false,
          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: true,
                      arrows: true,
                  }
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: true,
                      arrows: true,
                  }
              }
          ]
      }
    )
  }

  document.querySelectorAll('.is-type-animated-number.wp-block-sowmedia-animated-number').forEach(el => {
    observer.observe(el);
  });

  if ( document.querySelector(".pop-up__copy-url__button") ) {
    document.querySelector(".pop-up__copy-url__button").addEventListener("click", function(){
      var copyText = document.getElementsByClassName("pop-up__copy-url__input");
      copyText[0].select();
      document.execCommand("copy");
    });
  }

  document.addEventListener('facetwp-refresh', function() {
    
      if(jQuery('.facetwp-template').hasClass('slick-initialized')){
          jQuery('.facetwp-template').hide().slick('unslick');
      }
      
  });

  document.addEventListener('facetwp-loaded', function() {
      slickInit();
      document.querySelectorAll('.posts__filters__reset button').forEach((item, i) => {

        item.onclick = () => {
    
          FWP.reset();
          
        };
    
      });
  });

});

function start_counter(number, el) {
  const targetNumber = parseFloat(number);
  const countElement = el;
  const duration = 2000;
  const step = 16;
  const frames = duration / step;
  const increment = (targetNumber - 0) / frames;
  const hasDecimalPlaces = !Number.isInteger(targetNumber);

  let currentNumber = 0;
  const interval = setInterval(() => {
      currentNumber += increment;

      if (hasDecimalPlaces) {
          countElement.textContent = format_number(currentNumber.toFixed(1));
      } else {
          countElement.textContent = format_number(Math.round(currentNumber));
      }

      if (currentNumber >= targetNumber) {
          clearInterval(interval);
          countElement.textContent = hasDecimalPlaces ? format_number(targetNumber.toFixed(1)) : format_number(Math.round(targetNumber));
      }
  }, step);
}

function format_number(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}


jQuery( $ => {
  jQuery('.share-icon').on('click',function() {
      $('.pop-up').toggleClass('active');
      $('body').toggleClass('filter-active');
  });
});

jQuery( $ => {
  $( ".pop-up__close" ).on( "click", function() {
      $('.pop-up').toggleClass('active');
      $('body').toggleClass('filter-active');
    }
  );
});